import { render } from "./ToastsContainer.vue?vue&type=template&id=8abd0090"
import script from "./ToastsContainer.vue?vue&type=script&lang=ts"
export * from "./ToastsContainer.vue?vue&type=script&lang=ts"
script.render = render

export default script